import GenericViewOffline from '../../GenericViewOffline';

export default class user_menu_view extends GenericViewOffline {
    constructor(uri, app, className, data) {
        super(uri, app, (className || 'user_menu_view'), data);
    }
}
